/* Bague Elora — ajouts au tiroir du panier :
   1) pastilles de pierre a cote des mois
   2) timer de reservation de 5 min, qui BOUCLE et ne vide jamais le panier
   3) coffret cadeau a 5 $, en vraie ligne de commande

   🔴 REGLE DE STABILITE : on ne DETRUIT jamais un bloc pour le recreer. Chaque suppression
   redeclenche le MutationObserver, qui relance le cycle : le bloc clignote sans fin et le
   panier a l'air casse. On cree une fois, puis on met a jour en place. */
(() => {
  if (window.__eloraCartExtras) return;
  window.__eloraCartExtras = true;
  const CFG = window.ELORA_CFG || {};
  const PIERRES = CFG.pierres || [];
  const T = CFG.i18n || {};
  const RESERVE_MIN = 5;

  const css = `
  .elora-bs{display:flex;flex-wrap:wrap;align-items:center;gap:4px 12px;margin:2px 0 0}
  .elora-bs__i{display:inline-flex;align-items:center;gap:5px}
  .elora-bs__i img{width:15px;height:19px;object-fit:contain;display:block}
  .elora-rsv{display:flex;align-items:center;justify-content:center;gap:8px;
    margin:0 0 8px;padding:9px 14px;border-radius:2px;
    background:#F4EEE6;border:1px solid #E3D6C6;color:#3A2C1E;
    font-family:Outfit,sans-serif;font-size:12px;line-height:1.35;text-align:center}
  /* 🔴 28/09 : tout le haut du tiroir est COMPACTE pour laisser voir la bague, le
     coffret et une 2e ligne sans faire defiler. Ordre impose : timer de reservation,
     PUIS bandeau d'offre. Les deux blocs sont colles au titre du panier. */
  #dvl-offer-bar,#svl-offer-bar{padding:0 16px!important}
  #dvl-offer-bar .svcb,#svl-offer-bar .svcb{margin:0 0 12px!important;padding:8px 14px!important}
  .elora-rsv svg{width:14px;height:14px;flex-shrink:0;stroke:#8A6B4B}
  .elora-rsv b{font-weight:600;font-variant-numeric:tabular-nums;color:#8A6B4B}
  .elora-gift{display:flex;align-items:center;gap:11px;margin:0 0 14px;padding:10px 12px;
    border:1px solid #E6DED3;border-radius:3px;background:#FBF8F4;
    font-family:Outfit,sans-serif;color:#3A2C1E}
  .elora-gift__img{width:46px;height:46px;flex-shrink:0;border-radius:2px;object-fit:cover;background:#F1EAE1}
  .elora-gift__txt{flex:1;min-width:0}
  .elora-gift__t{display:block;font-size:12.5px;font-weight:600;line-height:1.3}
  .elora-gift__d{display:block;margin-top:1px;font-size:11.5px;line-height:1.3;color:#7A6A58}
  .elora-gift__p{flex-shrink:0;font-size:12.5px;font-weight:600;color:#8A6B4B;white-space:nowrap}
  .elora-gift__sw{position:relative;flex-shrink:0;width:38px;height:22px;border:0;padding:0;cursor:pointer;
    border-radius:11px;background:#DCD2C5;transition:background .18s ease}
  .elora-gift__sw::after{content:"";position:absolute;top:3px;left:3px;width:16px;height:16px;
    border-radius:50%;background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.2);transition:transform .18s ease}
  .elora-gift__sw[aria-pressed="true"]{background:#8A6B4B}
  .elora-gift__sw[aria-pressed="true"]::after{transform:translateX(16px)}
  .elora-gift__sw[disabled]{opacity:.5;cursor:wait}`;
  if (!document.getElementById("elora-extras-css")) {
    const s = document.createElement("style"); s.id = "elora-extras-css";
    s.textContent = css; document.head.appendChild(s);
  }

  /* 🔴 Tant que ce drapeau est leve, l'observateur ignore ce qui bouge : sinon nos propres
     ecritures relancent le cycle en boucle et tout clignote. */
  let jEcris = false;
  const ecrire = (fn) => {
    jEcris = true;
    try { fn(); } finally { setTimeout(() => { jEcris = false; }, 80); }
  };

  const moisDe = (item) => {
    const ref = (item.properties || {})._stone_ref;
    if (!ref) return null;
    const p = String(ref).split("/").map(x => parseInt(x.trim(), 10) - 1);
    return (p.length === 2 && p.every(n => n >= 0 && n <= 11)) ? p : null;
  };

  /* ------------------------------------------------------------ 1. PASTILLES */
  function poserPastilles(ligne, item) {
    const idx = moisDe(item);
    if (!idx || PIERRES.length !== 12) return;
    /* 🔴 On cible par l'INTITULE : sur Dravella la taille s'ecrit "M · US 7" et contient
       le meme separateur que les pierres. */
    const etiqs = [(T.labelPierres || "birthstone").toLowerCase(), "birthstone"];
    const bloc = [...ligne.querySelectorAll(".product-option")].find(o => {
      const dt = o.querySelector("dt");
      return dt && etiqs.some(e => dt.textContent.toLowerCase().includes(e));
    });
    const dd = bloc && bloc.querySelector("dd");
    if (!dd || dd.dataset.eloraBs === String(idx)) return;   /* deja pose : on ne retouche pas */
    const brut = dd.textContent.replace(/\s+/g, " ").trim();
    let noms = brut.split("·").map(x => x.trim()).filter(Boolean);
    if (noms.length !== 2 && Array.isArray(T.mois)) noms = [T.mois[idx[0]], T.mois[idx[1]]];
    if (noms.length !== 2) return;
    ecrire(() => {
      dd.dataset.eloraBs = String(idx);
      dd.innerHTML = '<span class="elora-bs">' + idx.map((n, k) =>
        `<span class="elora-bs__i"><img src="${PIERRES[n]}" alt="" loading="lazy">${noms[k]}</span>`
      ).join("") + "</span>";
    });
  }

  /* --------------------------------------------------------------- 2. TIMER */
  const CLE = "elora_rsv";
  const debut = () => {
    let t = parseInt(sessionStorage.getItem(CLE) || "0", 10);
    if (!t) { t = Date.now(); try { sessionStorage.setItem(CLE, String(t)); } catch (e) {} }
    return t;
  };
  const CHRONO =
    '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" ' +
    'stroke-linejoin="round"><circle cx="12" cy="13" r="8"/><path d="M12 9.5V13l2.2 1.6"/>' +
    '<path d="M9 2h6"/></svg>';
  let tic = null;

  function poserTimer(vide) {
    const hote = document.querySelector("cart-drawer .drawer__inner, .cart__items, #main-cart-items");
    let el = document.querySelector(".elora-rsv");
    if (vide || !hote) {
      if (el) ecrire(() => el.remove());
      if (tic) { clearInterval(tic); tic = null; }
      return;
    }
    if (!el) {
      ecrire(() => {
        const n = document.createElement("div");
        n.className = "elora-rsv";
        const cible = hote.querySelector(".drawer__header");
        if (cible) cible.after(n); else hote.prepend(n);
      });
    }
    if (tic) return;                                  /* deja en marche : on ne relance pas */
    const t0 = debut(), CYCLE = RESERVE_MIN * 60000;
    const battre = () => {
      const cible = document.querySelector(".elora-rsv");
      if (!cible) { clearInterval(tic); tic = null; return; }
      /* 🔴 Le compte a rebours BOUCLE : a 0 il repart a 5:00. Il ne vide JAMAIS le panier
         et n'annonce jamais une reservation perdue — il ne sert qu'a creer de l'urgence. */
      const reste = CYCLE - ((Date.now() - t0) % CYCLE);
      const m = Math.floor(reste / 60000), s = Math.floor((reste % 60000) / 1000);
      const html = CHRONO + "<span>" + (T.reserve || "Your order is reserved for") +
        " <b>" + m + ":" + String(s).padStart(2, "0") + "</b></span>";
      if (cible.innerHTML !== html) ecrire(() => { cible.innerHTML = html; });
    };
    battre(); tic = setInterval(battre, 1000);
  }

  /* ----------------------------------------------------- 3. COFFRET CADEAU */
  /* 🔴 Vraie ligne de commande, pas une propriete : il faut facturer les 5 $ et que
     l'agent voie le coffret dans la commande. */
  let verrou = false;
  function poserCoffret(cart) {
    const hote = document.querySelector("cart-drawer .cart-drawer__footer, .cart__footer, #main-cart-footer");
    let el = document.querySelector(".elora-gift");
    if (!hote || !CFG.giftVariant || cart.item_count === 0) {
      if (el) ecrire(() => el.remove());
      return;
    }
    const ligne = cart.items.find(i => String(i.variant_id) === String(CFG.giftVariant));
    const actif = !!ligne;
    if (!el) {
      ecrire(() => {
        const n = document.createElement("div");
        n.className = "elora-gift";
        n.innerHTML =
          `<img class="elora-gift__img" src="${CFG.giftImg || ""}" alt="" loading="lazy">` +
          `<span class="elora-gift__txt"><span class="elora-gift__t"></span>` +
          `<span class="elora-gift__d"></span></span>` +
          `<span class="elora-gift__p">+ ${CFG.giftPrix || "$5"}</span>` +
          `<button type="button" class="elora-gift__sw"></button>`;
        n.querySelector(".elora-gift__t").textContent = T.giftTitre || "Is this a gift?";
        n.querySelector(".elora-gift__d").textContent = T.giftTexte || "Add a gift box to your order.";
        n.querySelector(".elora-gift__sw").addEventListener("click", basculer);
        hote.prepend(n);
      });
      el = document.querySelector(".elora-gift");
      if (!el) return;
    }
    /* 🔴 On ne touche QUE ce qui change. Reecrire le bloc entier rechargerait l'image a
       chaque passage — c'est exactement ce qui la faisait clignoter. */
    const sw = el.querySelector(".elora-gift__sw");
    if (sw && sw.getAttribute("aria-pressed") !== String(actif)) {
      ecrire(() => sw.setAttribute("aria-pressed", String(actif)));
    }
    el.dataset.key = ligne ? ligne.key : "";
  }

  async function basculer(ev) {
    if (verrou) return;                     /* sans verrou, deux clics = deux coffrets */
    verrou = true;
    const b = ev.currentTarget; b.disabled = true;
    const bloc = b.closest(".elora-gift");
    const key = bloc && bloc.dataset.key;
    try {
      if (key) {
        await fetch("/cart/change.js", { method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 }) });
      } else {
        const r = await fetch("/cart/add.js", { method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(CFG.giftVariant), quantity: 1 }] }) });
        if (!r.ok) console.warn("[elora] coffret refuse :", (await r.json()).description);
      }
      const d = document.querySelector("cart-drawer");
      if (d && typeof d.renderContents === "function") {
        const s = d.getSectionsToRender ? d.getSectionsToRender().map(x => x.id) : [];
        const r = await fetch(`${window.location.pathname}?sections=${s.join(",")}`);
        d.renderContents({ sections: await r.json() });
      }
    } catch (e) {} finally { verrou = false; b.disabled = false; plusTard(); }
  }

  /* ------------------------------------------------------------ orchestration */
  let enCours = false;
  async function rafraichir() {
    if (enCours) return; enCours = true;
    try {
      const cart = await fetch("/cart.js").then(r => r.json());
      poserTimer(cart.item_count === 0);
      poserCoffret(cart);
      if (cart.item_count === 0) { try { sessionStorage.removeItem(CLE); } catch (e) {} }
      const lignes = document.querySelectorAll(
        "cart-drawer .cart-item, cart-drawer tr.cart-item, #main-cart-items .cart-item");
      cart.items.forEach((it, i) => { if (lignes[i]) poserPastilles(lignes[i], it); });
    } catch (e) {} finally { enCours = false; }
  }
  let attente = null;
  const plusTard = () => { clearTimeout(attente); attente = setTimeout(rafraichir, 160); };
  document.addEventListener("DOMContentLoaded", plusTard);
  if (document.readyState !== "loading") plusTard();
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, plusTard);
  }
  (function surveille() {
    const d = document.querySelector("cart-drawer") || document.querySelector("#main-cart-items");
    if (!d) return setTimeout(surveille, 500);
    new MutationObserver(() => { if (!jEcris) plusTard(); }).observe(d, { childList: true, subtree: true });
    plusTard();
  })();
})();
